import axios from 'axios'
import Vue from 'vue'
import _ from 'lodash'

const API_URL = process.env.API_ENDPOINT
const ADM_URL = process.env.ADM_ENDPOINT

const securedAxiosInstance = axios.create({
  baseURL: API_URL + '/api',
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

const plainAxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

securedAxiosInstance.interceptors.request.use((request) => {
  // ADMからのアクセスだった場合、APIのホストを変更する
  if (window.location.origin === ADM_URL) request.baseURL = ADM_URL + '/api/adm'
  return request
})

securedAxiosInstance.interceptors.response.use(null, error => {
  if (window.location.origin === ADM_URL) { // ADMからのアクセスの場合
    errorHandlingForAdm(error)
  } else {
    errorHandling(error)
  }
  return Promise.reject(error)
})

plainAxiosInstance.interceptors.request.use((request) => {
  // ADMからのアクセスだった場合、ホストを変更する
  if (window.location.origin === ADM_URL) request.baseURL = ADM_URL
  return request
})

const errorHandling = (error) => {
  if (!error.response || error.response.status === 500) {
    window.location.replace('/#/500')
  } else if (error.response.status === 403) {
    // 認可失敗した場合
    window.location.replace('/#/dashboard')
  } else if (error.response.status === 404) {
    // 404が返却された場合
    window.location.replace('/#/404')
    window.location.reload()
  } else if (error.response.status === 401 || error.response.status === 503) {
    // 認証失敗した場合 またはメンテナンス時
    window.location.hash = '/'
    window.location.reload()
  } else {
    otherErrorToasted(error)
  }
}

const errorHandlingForAdm = (error) => {
  if (!error.response || error.response.status === 500) {
    window.location.replace('/500.jsp')
  } else if (error.response.status === 403) {
    // 認可失敗した場合
    window.location.replace('/authority_error.jsp')
  } else if (error.response.status === 404) {
    // 404が返却された場合
    window.location.replace('/400.jsp')
  } else if (error.response.status === 401 || error.response.status === 503) {
    // 認証失敗した場合 またはメンテナンス時
    window.location.replace('/')
  } else {
    otherErrorToasted(error)
  }
}

const otherErrorToasted = (error) => {
  // 現状、応募者一覧のみ右上にトーストを表示するため,また比較対象はhashで比較(hashモードのため)
  const positionRightTopViews = ['#/applicants/']
  const message = _.defaultTo(_.get(error, 'response.data.message'), '').replace(/¥n/g, '\n')
  positionRightTopViews.includes(window.location.hash)
    ? Vue.toasted.global.errorRightTop({ message }) : Vue.toasted.global.error({ message })
}

export { securedAxiosInstance, plainAxiosInstance }
